// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';
import { type IncomingPayment, getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey } from '@tectonics/prs/merchant';
import { type Card, tokenize, formatExpiryDate } from '@tectonics/prs/card';
import { detectCardBrand } from '@tectonics/prs/card-brand';
import { type OutgoingPaymentTokenizedCard } from '@tectonics/prs/card/tokenized';

export async function debitCardOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
): Promise<$Shape<OutgoingPayment>> {

  const brand = detectCardBrand(userInputValues['cardNumber']) || '';

  const card: Card = {
    brand: brand || '',
    holderName: userInputValues['cardHolderName'],
    cardNumber: userInputValues['cardNumber'],
    expiryDate: formatExpiryDate(userInputValues['cardExpiryDate']),
    securityCode: userInputValues['cardSecurityCode'],
  };

  const merchant = getMerchant(incomingPayment);
  const country = getCountry(incomingPayment);
  const publicIntegrationKey = getPublicIntegrationKey(merchant);

  const tokenizedCard: OutgoingPaymentTokenizedCard = await tokenize({
    card,
    country,
    publicIntegrationKey,
    paymentTypeCode: 'debitcard',
  });

  return {
    card: { ...tokenizedCard, card_cvv: card.securityCode },
    payment_type: 'debitcard',
    payment_type_code: 'debitcard',
  };
}
